import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import deleteIcon from "../assets/images/deleteIcon.svg";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import { Box, Modal } from "@mui/material";
import infoIcon from "../assets/images/info-icon.svg";
import closeIcon from "../assets/images/cross-close.svg";
import pdfpage01 from "../assets/pdf/pdfpage01.jpg";
import pdfpage02 from "../assets/pdf/pdfpage02.jpg";
import { jsPDF } from "jspdf";
import dayjs from "dayjs";
import "dayjs/locale/he";
import checkmark from "../assets/images/check-mark-popup.png";

const COMPLETE_HOOK_URL = "https://hook.eu1.make.com/tbvuwpt37irg5u5tahm5b8b7jt5pewoa";
const SF_LEAD_URL = `${process.env.REACT_APP_BE_BASE_URL}salesforce/lead`;

const UserSignature = () => {
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(""); // Add state for imageUrl
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawing, setIsDrawing] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { email, phoneNumber, fullName } = location.state || {};
  const [searchParams, setSearchParams] = useSearchParams();
  const [successopen, setsuccessopen] = useState(false);
  const modalStyle1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: 24,
    height: {
      xs: "80vh",
      sm: "80vh",
      md: "80vh",
      lg: "auto",
      xl: "auto",
    },
    p: {
      xs: 4,
      sm: 6,
      md: 8,
      lg: 10,
      xl: 12,
    },
    outline: "none",
    textAlign: "center",
    direction: "rtl",
  };
  const handleClose1 = () => {
    setsuccessopen(false);
  };
  useEffect(() => {
    if (!email && !searchParams.get("skip")) {
      navigate("/register?step=1");
    }
  }, []);
  const initializeCanvas = () => {
    const canvas = canvasRef.current;
    const parent = canvas.parentElement;

    if (canvas && parent) {
      const parentWidth = parent.offsetWidth;
      const devicePixelRatio = window.devicePixelRatio || 1;

      canvas.width = parentWidth * devicePixelRatio;
      canvas.height = 184 * devicePixelRatio;

      const ctx = canvas.getContext("2d");
      ctx.scale(devicePixelRatio, devicePixelRatio);
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#1b1b1b";
    }
  };

  useEffect(() => {
    initializeCanvas();
    window.addEventListener("resize", initializeCanvas);

    const handleTouchMove = (e) => {
      if (e.target === canvasRef.current) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      window.removeEventListener("resize", initializeCanvas);
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { offsetX, offsetY } = getCanvasPosition(e);
    ctx.beginPath();
    ctx.moveTo(offsetX, offsetY);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { offsetX, offsetY } = getCanvasPosition(e);
    ctx.lineTo(offsetX, offsetY);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const getCanvasPosition = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    let offsetX, offsetY;
    if (e.touches) {
      const touch = e.touches[0];
      offsetX = touch.clientX - rect.left;
      offsetY = touch.clientY - rect.top;
    } else {
      offsetX = e.nativeEvent.offsetX;
      offsetY = e.nativeEvent.offsetY;
    }
    return { offsetX, offsetY };
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  const saveSignature = async () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/png");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", dataURL);
      formData.append("upload_preset", "signature");

      const cloudinaryResponse = await axios.post(
        "https://api.cloudinary.com/v1_1/deceg51ej/image/upload",
        formData,
      );
      const imageUrl = cloudinaryResponse.data.secure_url;
      setImageUrl(imageUrl);
      const pdf = new jsPDF();
      pdf.addImage(pdfpage01, "JPEG", 0, 0, 210, 297);
      pdf.addImage(imageUrl, "PNG", 70, 92, 10, 5);
      pdf.addPage();
      pdf.addImage(pdfpage02, "JPEG", 0, 0, 210, 297);
      pdf.addImage(imageUrl, "PNG", 125, 120, 10, 5);
      pdf.addImage(imageUrl, "PNG", 125, 260, 10, 5);
      // pdf.save("signature.pdf");

      const pdfBlob = pdf.output("blob");

      const pdfFormData = new FormData();
      pdfFormData.append("file", pdfBlob, "signature.pdf");
      pdfFormData.append("upload_preset", "signature");

      const pdfUploadResponse = await axios.post(
        "https://api.cloudinary.com/v1_1/deceg51ej/image/upload",
        pdfFormData,
      );

      const pdfUrl = pdfUploadResponse.data.secure_url;
      console.log("pdfUrl", pdfUrl);

      const apiResponse = await axios.post(
        `${process.env.REACT_APP_BE_BASE_URL}user/register?step=6`,
        {
          signature: imageUrl,
          signedPdf: pdfUrl,
          email,
        },
      );
      clearCanvas();

      if (apiResponse.status === 200) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "lead_form_submit",
          form_name: "register_step_6_lead_form",
          form_id: `register_step_6_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
          page_url: window.location.href,
        });
        console.log("GTM lead_form_submit event fired for register step 6");
        const nameParts6 = (fullName || "").trim().split(/\s+/);
        const sfPayload6 = {
          ProFin__First_Name__c: nameParts6.slice(0, -1).join(" ") || nameParts6[0] || "",
          ProFin__Last_Name__c: nameParts6.length > 1 ? nameParts6[nameParts6.length - 1] : nameParts6[0] || "",
          ProFin__Email__c: email,
          ProFin__Mobile_Phone__c: phoneNumber,
          ProFin__Status__c: "Sixth Step Completed",
          ProFin__Source__c: "Web",
          Source_App__c: "Web App",
        };
        const logSfCall6 = (logs) => {
          axios.post(`${process.env.REACT_APP_BE_BASE_URL}api-log/save`, { logs }).catch(() => {});
        };
        axios.post(SF_LEAD_URL, sfPayload6)
          .then((r) => {
            console.log("SF Lead Step 6:", r.status);
            logSfCall6([{
              email, full_name: fullName, phone_number: phoneNumber,
              page: "UserSignature", registration_step: "step_6",
              api_name: "salesforce_lead_direct", api_url: SF_LEAD_URL,
              was_called: true, skip_reason: null,
              request_payload: sfPayload6,
              response_status: r.status, response_settled: "fulfilled",
              response_data: r.data || null, error_message: null,
            }]);
          })
          .catch((e) => {
            console.error("SF Lead Step 6 failed:", e?.message);
            logSfCall6([{
              email, full_name: fullName, phone_number: phoneNumber,
              page: "UserSignature", registration_step: "step_6",
              api_name: "salesforce_lead_direct", api_url: SF_LEAD_URL,
              was_called: true, skip_reason: null,
              request_payload: sfPayload6,
              response_status: e?.status || null, response_settled: "rejected",
              response_data: e?.response?.data || null, error_message: e?.message || null,
            }]);
          });
        axios.post(COMPLETE_HOOK_URL, {
          full_name: fullName,
          email,
          phone_number: phoneNumber,
          idNumber: location?.state?.idNumber,
          birthDate: location?.state?.birthDate,
          issueDate: location?.state?.issueDate,
          signature: imageUrl,
          signedPdf: pdfUrl,
        }).catch(() => {});
        setsuccessopen(true);
        // await checkUserDetails();
      }
    } catch (error) {
      console.error("Error saving signature:", error);
      toast.error("Unable to save data, please try again");
    } finally {
      setLoading(false);
    }
  };
  const redirectToHme = async () => {
    navigate("/");
    setsuccessopen(false);
    setLoading(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "calc(100% - 40px)",
    maxWidth: "70vw",
    maxHeight: "90vh",
    bgcolor: "background.paper",
    borderRadius: "22px",
    boxShadow: 24,
    p: "10px 20px",
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="form_box">
      <h2 className="box_head">יפוי כוח לאיסוף המידע</h2>
      <p className="login_label">
        כדי שנוכל להשלים את איסוף המיידעים אנחנו צריכים את יפוי הכוח שלכם לגישה
        למידע, יפוי הכוח הוא בעצם האישור שלכם לאפשר לנו לגשת אל כל אחד מערוצי
        המידע ולאסוף עבורכם את המידע.{" "}
      </p>
      <span className="info_text" onClick={handleOpen}>
        <img className="info_icon" src={infoIcon} alt="info" />
        על מה אני חותם?{" "}
      </span>
      <h3>חתימה אחת ועוד כ-72 שעות המידע אצלכם!</h3>
      <div className="signature-container">
        <canvas
          ref={canvasRef}
          className="sing_canvas"
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={stopDrawing}
          onTouchStart={startDrawing}
          onTouchMove={draw}
          onTouchEnd={stopDrawing}
        />
        <img
          onClick={clearCanvas}
          className="delete_icon"
          src={deleteIcon}
          alt="delete"
        />
      </div>
      <button onClick={saveSignature} className="login_btn" disabled={loading}>
        {loading ? (
          <>
            <span>מכין את הנתונים</span>
            <span className="loader-spinner"></span>
          </>
        ) : (
          "המשך"
        )}
      </button>
      {/* <Link to="/" className='quit_link'>לדלג</Link> */}
      {/* <div
        className="text-center"
        onClick={() => {
          checkUserDetails()
          navigate("/", { state: { email } })
        }}
      >
        <span className="link_btn">לדלג</span>
      </div> */}
      <Modal open={open}>
        <Box sx={{ ...modalStyle }}>
          <div className="m-close">
            <img src={closeIcon} alt="close" onClick={handleClose} />
          </div>
          <div className="pdf-container">
            <div className="pdf-container-inner-1">
              <img
                src={pdfpage01}
                alt="pdfpage01"
                className="pdf-page pdf-page-01"
              />
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="Signature"
                  className="signature-image-01"
                  style={{
                    position: "absolute",
                    top: "30%",
                    left: "25%",
                    width: "50px",
                  }}
                />
              )}
            </div>
            <div className="pdf-container-inner-2">
              <img
                src={pdfpage02}
                alt="pdfpage02"
                className="pdf-page pdf-page-02"
              />
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="Signature"
                  className="signature-image-02"
                  style={{
                    position: "absolute",
                    top: "40%",
                    left: "60%",
                    width: "50px",
                  }}
                />
              )}
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt="Signature"
                  className="signature-image-03"
                  style={{
                    position: "absolute",
                    top: "86%",
                    left: "60%",
                    width: "50px",
                  }}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <Modal open={successopen} onClose={handleClose1}>
        <Box sx={modalStyle1}>
          <div className="registration-success">
            <div>
              <img
                src={checkmark}
                alt="success"
                className="registration-icon"
              />
              <h2 className="registration-title">ההרשמה הושלמה</h2>
            </div>

            <div className="registration-text">
              <p>
                כעת אנחנו נפנה לכל אחד מערוצי המידע הרלוונטים לקבלת המידע שלכם.
                <br />
                המידע יתקבל עד 72 שעות (3 ימי עסקים) ובסופו תהיה לך תמונת מצב
                מלאה לגבי כל אחד מהמוצרים הפנסיונים שלכם. אתם מוזמנים לקפוץ
                למערכת בקרוב לראות את המידע ואנו גם נשלח לכם הודעת ווצאפ כשהמידע
                יופיע אצלכם במערכת..
              </p>

              <p>
                נרשמתם והמידע עדיין לא מופיע? זה בסדר, לוקח לנו כ-72 שעות לאסוף
                את המידע ולנתח אותו.
                <br />
                אתם לא צריכים לחכות, כשהנתונים יהיו מוכנים אנחנו נשלח לכם הודעה
                לוואטסאפ.
                <br />
                עברו יותר מ-72 שעות והמידע עדיין לא התקבל? <br />
                במידת הצורך.
              </p>

              <p>
                <b>
                  עד שנהיה מוכנים, אתם מוזמנים לקבל מידע וכלים פיננסים בפורטל
                  שלנו,
                  <br />
                  שם תמצאו מדריכים פיננסים, כתבות, פודקאסטים וכל מה שצריך לדעת
                  כדי לעשות יותר
                  <br />
                  עם הכסף שלכם.
                </b>
              </p>

              <p>
                <a
                  href="/update-data"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  עדכון נתונים
                </a>
              </p>
            </div>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <button
                className="btn-m btn-outline"
                onClick={() => {
                  navigate("/");
                }}
              >
                קחו אותי לפורטל
              </button>
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default UserSignature;
